import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=800c7802&scoped=true&"
import script from "./Jumbotron.vue?vue&type=script&lang=js&"
export * from "./Jumbotron.vue?vue&type=script&lang=js&"
import style0 from "./Jumbotron.vue?vue&type=style&index=0&id=800c7802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800c7802",
  null
  
)

export default component.exports